// src/maintenance/components/JobStatus.js
import React from 'react';
import { useRecordContext } from 'react-admin';
import { Card, CardContent, Typography, Chip, Grid } from '@mui/material';
import { format } from 'date-fns';

const JobStatus = () => {
  const record = useRecordContext();
  
  const statusColors = {
    pending: 'default',
    uploaded: 'info',
    validated: 'warning',
    processed: 'success',
    failed: 'error',
  };
  
  const statusDescriptions = {
    pending: 'Rollback CSV generated. Download and edit it, then upload.',
    uploaded: 'Edited CSV uploaded. Review changes and validate.',
    validated: 'Changes validated. Ready to process.',
    processed: 'Changes have been committed to the database.',
    failed: 'Processing failed. Check error message below.',
  };

  return (
    <Card>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Job Status
            </Typography>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Typography variant="body2" color="text.secondary">
              Status
            </Typography>
            <Chip 
              label={record.status.toUpperCase()} 
              color={statusColors[record.status]}
              sx={{ mt: 1 }}
            />
            <Typography variant="body2" sx={{ mt: 1 }}>
              {statusDescriptions[record.status]}
            </Typography>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Typography variant="body2" color="text.secondary">
              Alumni Class
            </Typography>
            <Typography variant="body1" sx={{ mt: 1 }}>
              {record.alumni_class_name}
            </Typography>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Typography variant="body2" color="text.secondary">
              Created
            </Typography>
            <Typography variant="body1" sx={{ mt: 1 }}>
              {format(new Date(record.created_at), 'PPpp')}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              by {record.created_by}
            </Typography>
          </Grid>
          
          {record.processed_at && (
            <Grid item xs={12} md={6}>
              <Typography variant="body2" color="text.secondary">
                Processed
              </Typography>
              <Typography variant="body1" sx={{ mt: 1 }}>
                {format(new Date(record.processed_at), 'PPpp')}
              </Typography>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default JobStatus;